import type { SVGProps } from "react";
const SvgEntryDialogOkButton = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={116.22}
    height={124}
    fill="none"
    fillRule="evenodd"
    stroke="#000"
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    strokeWidth={0.501}
    fontFamily="Times New Roman"
    fontSize={16}
    overflow="visible"
    style={{
      fontVariantLigatures: "none",
    }}
    viewBox="473.747 -740.138 87.165 93"
    {...props}
  >
    <g stroke="none">
      <path
        fill="#387c47"
        d="M476.284-647.138h.156-.002l-.342-.001h-2.349.02v-92.999h78.096v.002a8.98 8.98 0 0 1 6.414 2.633c3.513 3.513 3.513 9.217 0 12.73l-.191.186-74.667 74.666.002-.001-.164.169a8.97 8.97 0 0 1-5.747 2.615l-1.018-.001-.051.001h-.001 1.07z"
      />
      <g
        fill="#262626"
        fillRule="nonzero"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.488}
      >
        <path d="M494.616-693.541q-3.063.405-5.032-1.039-1.97-1.444-2.356-4.363a15 15 0 0 1-.085-1.198l-.107-11.059q-.02-3.48 1.964-5.796 1.985-2.316 5.371-2.765 3.064-.406 5.072 1.053 2.008 1.457 2.394 4.376.048.36.08 1.162l.071 11.064q.057 3.476-1.964 5.796t-5.408 2.769m-.029-5.203a1.64 1.64 0 0 0 1.188-.725q.43-.626.445-1.617l-.137-11.568a2.6 2.6 0 0 0-.026-.473q-.1-.757-.518-1.141-.418-.385-1.102-.295-.758.1-1.186.744-.428.643-.411 1.594l.101 11.574.017.4q.105.793.525 1.195.42.404 1.104.312M504.626-695.159a.36.36 0 0 1-.304-.088.35.35 0 0 1-.114-.297l-.233-24.754a.6.6 0 0 1 .122-.328.42.42 0 0 1 .289-.166l4.973-.659a.37.37 0 0 1 .305.088q.124.113.112.297l.069 8.277q.02.144.091.135.073-.01.13-.128l3.588-8.907a.59.59 0 0 1 .497-.396l5.225-.692q.252-.033.341.084.089.116-.022.388l-4.94 11.433a1 1 0 0 0-.06.099q-.028.058.017.126l5.449 12.918.056.139a.33.33 0 0 1-.093.269.46.46 0 0 1-.292.15l-5.261.695q-.397.053-.51-.262l-3.207-8.155q-.05-.103-.124-.094-.07.01-.128.127l-.622 1.402a.6.6 0 0 0-.043.226l.073 6.921a.6.6 0 0 1-.122.327.42.42 0 0 1-.289.167z" />
      </g>
      <g
        fill="#f7e5c5"
        fillRule="nonzero"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.488}
      >
        <path d="M496.153-695.078q-3.063.405-5.032-1.039-1.97-1.444-2.356-4.363a14 14 0 0 1-.085-1.198l-.107-11.059q-.02-3.48 1.964-5.796 1.985-2.317 5.372-2.764 3.064-.406 5.071 1.052 2.007 1.457 2.394 4.376.048.361.08 1.162l.071 11.064q.057 3.476-1.963 5.796t-5.409 2.769m-.029-5.203a1.64 1.64 0 0 0 1.188-.725q.43-.626.446-1.617l-.138-11.567a2.6 2.6 0 0 0-.026-.474q-.1-.757-.518-1.142t-1.102-.294a1.62 1.62 0 0 0-1.185.744q-.428.643-.412 1.594l.102 11.573.016.401q.105.792.525 1.195.42.404 1.104.312M506.163-696.696a.37.37 0 0 1-.305-.088.35.35 0 0 1-.112-.297l-.234-24.754a.6.6 0 0 1 .122-.328.43.43 0 0 1 .289-.168l4.973-.657a.37.37 0 0 1 .304.087.35.35 0 0 1 .113.298l.069 8.277q.02.144.092.134t.129-.127l3.588-8.907a.59.59 0 0 1 .497-.396l5.225-.692q.252-.033.341.083.089.118-.022.388l-4.94 11.433a1 1 0 0 0-.06.1q-.028.06.017.126l5.45 12.918.055.139a.33.33 0 0 1-.093.269.46.46 0 0 1-.292.149l-5.261.696q-.397.053-.511-.262l-3.207-8.155q-.049-.103-.122-.094-.072.01-.129.127l-.621 1.402a.6.6 0 0 0-.044.226l.073 6.92a.6.6 0 0 1-.122.328.42.42 0 0 1-.289.166z" />
      </g>
    </g>
  </svg>
);
export default SvgEntryDialogOkButton;
